import { TokenClaimModel } from "../models/security.model";

const TOKEN_KEY = "tokenSupplier";
const REF_TOKEN_KEY = "refTokenKeySupplier";

export const setJwtToken = (token: string, refreshToken: string) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(REF_TOKEN_KEY, refreshToken);
};
interface objToken {
  token: string;
  refToken: string;
}
export const getJwtToken = (): objToken => {
  return {
    token: localStorage.getItem(TOKEN_KEY)!,
    refToken: localStorage.getItem(REF_TOKEN_KEY)!,
  };
};

export const getTokenClaims = (): TokenClaimModel | null => {
  const { token } = getJwtToken();
  if (token == undefined || token == "") return null;
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload) as TokenClaimModel;
};

export const isTokenValid = (): boolean => {
  const token = getJwtToken();
  if (!token) return false;
  const tokenClaims = getTokenClaims();
  if (!tokenClaims) return false;
  // if (tokenClaims.exp * 1000 < Date.now()) return false;
  return true;
};
